import { IButton } from 'parkdepot-shared/components/Buttons'
import { styled } from 'parkdepot-shared/theme'
import { colors } from 'parkdepot-shared/theme/colors'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
    margin: '0 1.5rem',
    borderRadius: $theme.sizing.scale400,
    border: `1px solid ${$theme.colors.mono200}`
}))

export const MapContainer = styled('div', {
    height: '220px'
})

export const Title = styled('div', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    minHeight: '2.6rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '2rem'
}))

export const CloseButton = styled('button', () => ({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.5rem'
}))

export const ButtonOverrides: IButton['overrides'] = {
    BaseButton: {
        style: {
            color: colors.buttonIconPrimaryText
        }
    }
}

export const SpinnerContainer = styled('div', ({ $theme }) => ({
    padding: `0 ${$theme.sizing.scale700}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))
